import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import SearchInput from "../common/FormInputs/SearchInput";
import { setSearchText } from "../redux/slices/isSearch";
import { QA_ROLES, roleDisplayNames } from "../constant";

const Header = () => {
  const { pathname } = useLocation();
  const role = useSelector((state) => state.auth.role);
  const searchText = useSelector((state) => state.search.searchText);
  const dispatch = useDispatch();
  const location = useLocation();
  const timeoutRef = useRef(null);

  const handleSearch = (event) => {
    const value = event.target.value;
    
    // Clear any pending timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    
    // Dispatch immediately if empty
    if (value === '') {
      dispatch(setSearchText(value));
      return;
    }
    
    // For regular typing, debounce the dispatch
    timeoutRef.current = setTimeout(() => {
      dispatch(setSearchText(value));
    }, 300);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      const value = event.target.value;
      // Clear any pending timeout
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      // Dispatch immediately on Enter
      dispatch(setSearchText(value));
    }
  };

  useEffect(() => {
    dispatch(setSearchText(""));
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }, [location.pathname]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <>
      <div className="welcom-main px-2 py-2 pt-4 pt-lg-0 mb-3 d-flex flex-column flex-md-row gap-3 gap-md-5 justify-content-between align-items-center">
        <div className="">
          {pathname === "/manage-qas" ? (
            <div className="welcome" style={{ fontFamily: "Gilroy-Medium" }}>
              <span className="superAdmin">Manage Users</span>
              <br />
              <span className="welcomeback">Add, edit, or remove Users</span>
            </div>
          ) : (
            <div className="welcome" style={{ fontFamily: "Gilroy-Medium" }}>
              <span className="welcomeback">Welcome back,</span>
              <br />
              <span className="superAdmin" style={{ whiteSpace: "nowrap" }}>
                {roleDisplayNames[role] || "Unknown Role"}
              </span>
            </div>
          )}
        </div>
        <div className="d-flex w-100 w-md-50 justify-content-end">
          <div className="search-container">
            <SearchInput 
              onSearch={handleSearch} 
              onKeyPress={handleKeyPress}
              value={searchText} 
            />
          </div>
          <div className="d-flex align-items-center gap-3 notification-user-container">
            <button type="button" className="btn btn-link p-0 notification-btn">
              <i className="bi bi-bell"></i>
            </button>
            <img
              src="https://images.unsplash.com/photo-1502685104226-ee32379fefbe"
              alt="User Avatar"
              className="user-avatar"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;